import * as actionTypes from "../Actions/actionTypes.js";

const initialState = {
  benefitsDetails: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_BENEFITS:
      return { ...state, benefitsDetails: action.value };

    case actionTypes.SET_BENEFITS_ATTR:
      return { ...state, benefitsDetails: { ...state.benefitsDetails, ...action.obj } };

    case actionTypes.CLEAR_BENEFITS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
